export default "__VITE_ASSET__BIqmUkm___"